<template>
  <q-a-card
    type="Answer"
    deletable
    editable
    checkbox
    add
    :valid="valid"
    :items="answers"
    @get-items="getAnswers"
    @put-item="putAnswers"
    @post-item="postAnswers"
    @edit-item="editAnswers"
    @delete-item="deleteAnswers"
    @modal-close="resetForm"
  >
    <template slot="title">Answers</template>
    <template slot="subTitle">Select one correct answer</template>
    <template slot="dialog"
      ><v-form ref="form">
        <v-text-field
          v-model="answer.answerText"
          label="Answer"
          placeholder="Enter Answer Here"
          type="text"
          value=""
        >
        </v-text-field>
        <v-checkbox
          color="red accent-4"
          v-model="answer.isCorrect"
          label="Is Correct Answer?"
        ></v-checkbox>
      </v-form>
    </template>
  </q-a-card>
</template>

<script>
import QACard from "@/components/test/QACard.vue";
import AnswerService from "@/services/AnswerService.js";
export default {
  props: {
    questionId: String
  },
  components: {
    QACard
  },
  data() {
    return {
      dialog: false,
      valid: "",
      loading: false,
      answers: [],
      answer: {}
    };
  },
  methods: {
    async getAnswers() {
      this.loading = true;
      try {
        this.answers = await AnswerService.getAnswersByQuestionId(
          this.questionId
        );
      } finally {
        this.loading = false;
      }
    },
    putAnswers() {
      if (this.$refs.form.validate()) {
        this.answer.questionId = this.questionId;
        AnswerService.putAnswer(this.answer).then(() => {
          this.getAnswers(),
            this.$snackbarSuccess("Answer Successfully Edited");
        });
      }
    },
    postAnswers() {
      if (this.$refs.form.validate()) {
        this.answer.questionId = this.questionId;
        AnswerService.postAnswer(this.answer).then(() => {
          this.getAnswers(), this.$snackbarSuccess("Answer Successfully Added");
        });
      }
    },
    editAnswers(item) {
      this.answer = Object.assign({}, item);
    },
    deleteAnswers(item) {
      AnswerService.deleteAnswer(item.answerId).then(() => {
        this.getAnswers(), this.$snackbarSuccess("Answer Deleted");
      });
    },
    resetForm() {
      this.$refs.form.reset();
    }
  }
};
</script>
